// jshint module: true

export default class Component {

  constructor(name, element, options = {}) {

    if (element.instance) {
      return;
    }

    this.name = name;
    this.element = element;
    this.selector = `.${this.name}`;

    this.options = Object.assign({}, {
      onLoad: true,
      onContentLoad: false,
      onDelayedLoad: false,
    }, options);

    if (this.options.onLoad) {
      window.addEventListener('init-load', this.init.bind(this));
    }

    if (this.options.onContentLoad) {
      window.addEventListener('init-content-load', this.init.bind(this));
    }

    if (this.options.onDelayedLoad) {
      window.addEventListener('init-delayed-load', this.init.bind(this));
    }

    // We return this object to bind the instance.
    return this;
  }

  static init() {
    // Override this method
  }

}



// WEBPACK FOOTER //
// ./website/assets/scripts/component/component.js